import { PoolViewContainerProps, PoolViewOwnPropsType } from 'components/views/PoolView';
import PoolView from 'components/views/PoolView';
import { POOL_CLUSTER, POOL_TYPE } from 'defs/pools';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFavoriteIds, getFavoritesForPool } from 'store/favorites';
import { actionCreators as favoritesAC } from 'store/favorites';
import { RootStateType as FavoritesRootStateType } from 'store/favorites';
import { RootStateType as PoolRootStateType } from 'store/pools';
import { actionCreators as poolsAC, getIsPoolReady, getItemsFromPool, getPoolErrors, getPoolExists } from 'store/pools';
import { getCoach, getWeight } from 'store/profile';
import { RootStateType as ProfileRootStateType } from 'store/profile';
import { actionCreators as transientPoolStateAC } from 'store/transientPoolState';
import { RootStateType as TransientPoolStateType } from 'store/transientPoolState';

type RootStateType = PoolRootStateType & ProfileRootStateType & FavoritesRootStateType & TransientPoolStateType;

const mapStateToProps = (state: RootStateType, ownProps: PoolViewOwnPropsType): PoolViewContainerProps => {
	const { selectedPool, selectedCluster } = ownProps;

	let items: any[] = [];
	let total = -1;
	let signature = '';

	// Favourite Cluster
	if (selectedCluster && selectedCluster === POOL_CLUSTER.FAVORITE) {
		let dedicatedFavoriteCluster: 'WORKOUT' | 'RECIPE' | void;

		switch (selectedPool) {
			case POOL_TYPE.WORKOUT:
				dedicatedFavoriteCluster = 'WORKOUT';
				break;
			case POOL_TYPE.RECIPE:
				dedicatedFavoriteCluster = 'RECIPE';
				break;
			default:
				break;
		}

		const favorites = dedicatedFavoriteCluster
			? getFavoritesForPool(state, dedicatedFavoriteCluster)
			: { items: [] as any[], total: 0 };

		items = favorites.items;
		total = favorites.total;
		signature = items.map((item) => item.externalId).join('-');

		/*
		 * Return favorites from favorite store in case of
		 * requesting favorites tab because the favorites
		 * may not be available inside the selected pool.
		 */
		return {
			items,
			signature,
			total,
			loaded: true,
			valid: getPoolExists(state, selectedPool),
			errors: getPoolErrors(state, selectedPool),
			weight: getWeight(state) || 0,
			favoriteIds: getFavoriteIds(state),
			coach: getCoach(state),
			ready: getIsPoolReady(state, selectedPool),
		};
	}

	const poolResult = getItemsFromPool(state, selectedPool);
	items = poolResult.items;
	total = poolResult.total;
	signature = items.map((item) => item.externalId).join('-');

	// change signature for the CUSTOM tab, because it has the same items as the `all` cluster
	// which would lead to the same signature
	if (selectedCluster && selectedCluster === POOL_CLUSTER.CUSTOM) {
		signature = 'custom';
	}

	return {
		items,
		signature,
		total,
		loaded: true,
		valid: getPoolExists(state, selectedPool),
		errors: getPoolErrors(state, selectedPool),
		weight: getWeight(state) || 0,
		favoriteIds: getFavoriteIds(state),
		coach: getCoach(state),
		ready: getIsPoolReady(state, selectedPool),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doRequestPool: poolsAC.doRequestPool,
			doLoadFavorites: favoritesAC.doLoadFavorites,
			doSetPersistentFilter: transientPoolStateAC.doSetPersistentFilter,
			doUnsetPersistentFilter: transientPoolStateAC.doUnsetPersistentFilter,
			doSetProgramItemRef: transientPoolStateAC.doSetProgramItemRef,
			doUnsetProgramItemRef: transientPoolStateAC.doUnsetProgramItemRef,
			doSetOverlayRef: transientPoolStateAC.doSetOverlayRef,
			doUnsetOverlayRef: transientPoolStateAC.doUnsetOverlayRef,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(PoolView as any);
